/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_JOU_MANUAL_ITEM = {
  id: 'manual_entries',
  screenId: 'acc-jou-manual',
  label: 'Asientos manuales',
  description: 'Carga manual de asientos con debe y haber.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás asientos que no vienen de ventas/compras/cobros/pagos: ajustes, asientos de apertura o cierre, reclasificaciones.',
      },
      {
        title: 'Paso 1 — Nuevo asiento',
        fields: [
          { label: 'Fecha', description: 'Debe caer en un período abierto.' },
          { label: 'Concepto', description: 'Descripción del asiento.' },
          { label: 'Líneas', description: 'Cuenta contable, importe en Debe o Haber. Mínimo dos líneas.' },
        ],
        paragraphs: [
          'El total Debe debe igualar el total Haber (diferencia 0). Agregá líneas con + si hace falta.',
          'Guardá el asiento cuando esté balanceado.',
        ],
      },
      {
        title: 'Paso 2 — Listado',
        bullets: [
          'Últimos asientos manuales. Expandí uno para ver líneas y detalle.',
        ],
      },
    ],
  },
}
